// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginWithAuthorizationConfig__container-addb1d {
  margin: 0 -8px;
}

.LoginWithAuthorizationConfig__item-authorization-config-f398df {
  --login-authorization-config-item-icon-background: var(--brand-primary-40);
  --login-authorization-config-item-icon-color: var(--addition-50);
}

.LoginWithAuthorizationConfig__item-another-user-c7d18e {
  --login-authorization-config-item-icon-background: var(--base-20);
  --login-authorization-config-item-icon-color: var(--base-90);
}

.LoginWithAuthorizationConfig__item-icon-be1960 {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--login-authorization-config-item-icon-background);
  color: var(--login-authorization-config-item-icon-color);
}

:root[dir=rtl] .LoginWithAuthorizationConfig__chevronIcon-b90485 {
  transform: scaleX(-1);
}`, "",{"version":3,"sources":["webpack://./src/pages/authorization/Login/LoginViews/LoginWithAuthorizationConfig/LoginWithAuthorizationConfig.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,0EAAA;EACA,gEAAA;AACF;;AAGA;EACE,iEAAA;EACA,4DAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wEAAA;EACA,wDAAA;AAAF;;AAGA;EACE,qBAAA;AAAF","sourcesContent":[".container {\n  margin: 0 -8px;\n}\n\n.item-authorization-config {\n  --login-authorization-config-item-icon-background: var(--brand-primary-40);\n  --login-authorization-config-item-icon-color: var(--addition-50);\n}\n\n\n.item-another-user {\n  --login-authorization-config-item-icon-background: var(--base-20);\n  --login-authorization-config-item-icon-color: var(--base-90);\n}\n\n.item-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--login-authorization-config-item-icon-background);\n  color: var(--login-authorization-config-item-icon-color);\n}\n\n:root[dir='rtl'] .chevronIcon {\n  transform: scaleX(-1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoginWithAuthorizationConfig__container-addb1d`,
	"item-authorization-config": `LoginWithAuthorizationConfig__item-authorization-config-f398df`,
	"itemAuthorizationConfig": `LoginWithAuthorizationConfig__item-authorization-config-f398df`,
	"item-another-user": `LoginWithAuthorizationConfig__item-another-user-c7d18e`,
	"itemAnotherUser": `LoginWithAuthorizationConfig__item-another-user-c7d18e`,
	"item-icon": `LoginWithAuthorizationConfig__item-icon-be1960`,
	"itemIcon": `LoginWithAuthorizationConfig__item-icon-be1960`,
	"chevronIcon": `LoginWithAuthorizationConfig__chevronIcon-b90485`
};
module.exports = ___CSS_LOADER_EXPORT___;
